import Vue from 'vue'
import VueRouter from 'vue-router'
import routerActor from './actor'
import routerVisitor from './visitor'
import routerWorkbench from './workbench'
import config from '../config/index'

// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

/**
 * meta.pPath 用于顶部菜单 选中(尤其在详情页面，其父类菜单要求时选中的)
 * meta.head 默认显示导航1，2显示导航2, -1不显示导航
 * meta.whiteBackground: 默认为灰色背景 true 为白色背景
 */
const routes = [
    ...routerActor,
    ...routerVisitor,
    ...routerWorkbench,
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/home.vue'),
        meta: {
            title: 'baoiHome',
            head: 3
        }
    },
    {
        // 在线会议
        path: '/onLineMeeting',
        name: 'OnLineMeeting',
        component: () => import('../views/onLineMeeting/index.vue'),
        meta: {
            title: '在线会议',
            head: 3
        }
    },
    {
        // 直播详情
        path: '/onLineMeeting/:id',
        name: 'onLineMeetingDetail',
        component: () => import( /* webpackChunkName: "liveDetail" */ '../views/onLineMeeting/onLineMeetingDetail.vue'),
        meta: {
            head: 3,
            whiteBackground: true
        }
    },
    {
        // 关于我们
        path: '/aboutus',
        name: 'Aboutus',
        component: () => import('../views/aboutus.vue'),
        meta: {
            title: 'aboutus',
            head: 3
        }
    },
    {
        // 免责声明
        path: '/disclaimer',
        name: 'Disclaimer',
        component: () => import('../views/disclaimer.vue'),
        meta: {
            title: 'disclaimer',
            head: -1
        }
    },
    {
        // QA&A
        path: '/qa',
        name: 'Qa',
        component: () => import('../views/qa.vue'),
        meta: {
            title: 'qatitle',
            head: 3
        }
    },
    {
        // 工作台 采购对接会 表格
        path: '/procurementDocking',
        name: 'procurementDocking',
        component: () => import('../views/purchaseMeeting/procurementDocking.vue'),
        meta: {
            title: 'procurementDocking',
            roles: [ 'VISITOR', 'ACTOR', '' ],
            whiteBackground: true
        }
    },
    {
        // 采购对接会
        path: '/purchaseMeeting',
        name: 'purchaseMeeting',
        component: () => import('../views/purchaseMeeting/index.vue'),
        meta: {
            title: 'purchaseMeeting',
            head: 3
        }
    },
    {
        // 展商 采购对接会
        path: '/meetingList',
        name: 'meetingList',
        component: () => import('../views/meetingList/index.vue'),
        meta: {
            title: 'meetingList',
            head: 3
        }
    },
    {
        // 消息中心-发送消息
        path: '/chat',
        name: 'Chat',
        component: () => import('../views/chat/chat.vue'),
        meta: {
            title: 'notification',
            roles: ['VISITOR', 'ACTOR']
        }
    },
    {
        // 消息中心-消息列表
        path: '/mail',
        name: 'Mail',
        component: () => import('../views/chat/mail.vue'),
        meta: {
            title: 'notification',
            roles: ['VISITOR', 'ACTOR']
        }
    },
    {
        // 直播列表
        path: '/live',
        component: () => import('../views/live/index.vue'),
        children: [{
            path: '',
            name: 'liveList',
            alias: '/live/list',
            component: () => import('../views/live/liveMore.vue'),
            meta: {
                head: 3,
                title: 'homes.Live',
                roles: [ 'VISITOR', 'ACTOR', '' ]
            }
        } ]
    },
    {
        // 直播详情
        path: '/live/:id',
        name: 'liveDetail',
        component: () => import( /* webpackChunkName: "liveDetail" */ '../views/live/liveDetail.vue'),
        meta: {
            head: 3,
            roles: [ 'VISITOR', 'ACTOR', '' ],
            whiteBackground: true
        }
    },
    {
        // 3d展馆图
        path: '/map/:floor?',
        name: 'map',
        meta: {
            head: -1,
            title: 'baoiHome'
        },
        component: () => import( /* webpackChunkName: "map" */ '../views/map.vue')
    },
    {
        // 找客商，找展商，找展品
        path: '/find/:type(person|actor|product)',
        name: 'findList',
        component: () => import( /* webpackChunkName: "findList" */ '../views/find/list.vue'),
        meta: {
            head: 2,
            title: 'finds.',
            roles: {
                'person': ['ACTOR', ''],
                'actor': ['VISITOR', ''],
                'product': ['VISITOR', '']
            }
        }
    },
    {
        // 找商机 (商脉圈)
        path: '/find-opportunity',
        name: 'findOpportunity',
        component: () => import( /* webpackChunkName: "findOpportunity" */ '../views/find/findOpportunity.vue'),
        meta: {
            head: 2,
            title: 'finds.businessCircle',
            roles: ['VISITOR', 'ACTOR']
        }
    },
    {
        // 客商详情
        path: '/find-person/detail/:id',
        name: 'findPersonDetail',
        component: () => import( /* webpackChunkName: "findPersonDetail" */ '../views/find/findPersonDetail.vue'),
        meta: {
            pPath: '/find/person',
            head: 2,
            title: 'finds.personDetail',
            roles: ['ACTOR', '']
        }
    },
    {
        // 展品详情
        path: '/find-exhibit/detail/:id',
        name: 'findExhibitDetail',
        component: () => import( /* webpackChunkName: "findExhibitDetail" */ '../views/find/findExhibitDetail.vue'),
        props: true,
        meta: {
            pPath: '/find/product',
            head: 2,
            title: 'finds.productDetail',
            roles: ['VISITOR', '']
        }
    },
    {
        // 展商详情
        path: '/find-exhibitor/detail/:id',
        name: 'findExhibitorDetail',
        component: () => import( /* webpackChunkName: "findExhibitorDetail2" */ '../views/find/findExhibitorDetail2.vue'),
        props: true,
        meta: {
            pPath: '/find/actor',
            head: 2,
            title: 'finds.actorDetail',
            roles: ['VISITOR', '']
        }
    },
    // {
    //     // 登录页面
    //     path: '/login/:type?',
    //     name: 'login',
    //     component: () => import( /* webpackChunkName: "login" */ '../views/login/login.vue'),
    //     meta: {
    //         head: -1, //隐藏
    //         title: 'login'
    //     }
    // },
    {
        // 登录页面
        path: '/login/:type?',
        // path: '/login/person',
        name: 'login',
        component: () => import( /* webpackChunkName: "login" */ '../views/login/login.vue'),
        meta: {
            head: -1, //隐藏
            title: 'login'
        }
    },
    {
        // 邀约
        path: '/invite',
        name: 'invite',
        meta: {
            title: 'invitationManagement',
            whiteBackground: true,
            roles: ['VISITOR', 'ACTOR']
        },
        component: () => import('../views/invite/invite.vue')
    },
    {
        // 商机管理
        path: '/opportunity-manage/:action',
        name: 'opportunityManage',
        component: () => import( /* webpackChunkName: "opportunityManage" */ '../views/find/opportunityManage.vue'),
        meta: {
            title: 'marketing',
            whiteBackground: true,
            roles: ['VISITOR', 'ACTOR']
        }
    },
    {
        //隐私协议
        path: '/agreement',
        name: 'agreement',
        meta: {
            title: 'Privacy agreement',
            head: -1
        },
        component: () => import( /* webpackChunkName: "agreement" */ '../views/login/agreement.vue')
    },
    {
        // 个人中心
        path: '/personal',
        component: () => import( /* webpackChunkName: "personalCenter" */ '../views/personalCenter/index.vue'),
        children: [{
            // 修改密码
            path: '/personal/change-password',
            name: 'changePassword',
            component: () => import( /* webpackChunkName: "change-passwrod" */ '../views/personalCenter/changePassword.vue'),
            meta: {
                title: 'finds.changePass',
                pPath: '/personal/change-password',
                roles: ['VISITOR', 'ACTOR']
            }
        }, {
            // 问卷管理
            path: '/personal/questionnaire/:type(change)',
            name: 'changeQuestionnaire',
            component: () => import( /* webpackChunkName: "questionnaire" */ '../views/register/questionnaire.vue'),
            meta: {
                title: 'Survey Management',
                pPath: '/personal/questionnaire/change',
                roles: ['VISITOR', 'ACTOR']
            }
        }]
    },
    {
        //足迹 客商（person）,展商（exhibitor）,展品（product）
        path: '/footprint/:type(person|exhibitor|product)',
        name: 'footprintList',
        component: () => import( /* webpackChunkName: "footprintList" */ '../views/footprint/list.vue'),
        meta: {
            title: 'footprints.',
            pPath: {
                'VISITOR': '/footprint/exhibitor',
                'ACTOR': '/footprint/person'
            },
            roles: {
                'person': ['ACTOR'],
                'exhibitor': ['VISITOR'],
                'product': ['VISITOR']
            }
        }
    },
    {
        //收藏 客商（audience）,展商（exhibitor）,展品（product）
        path: '/collection/:type(audience|exhibitor|product)',
        name: 'CollectionList',
        meta: {
            title: 'myFavorite',
            pPath: {
                'VISITOR': '/collection/exhibitor',
                'ACTOR': '/collection/audience'
            },
            roles: {
                'audience': ['ACTOR'],
                'exhibitor': ['VISITOR'],
                'product': ['VISITOR']
            }
        },
        component: () => import('../views/collection/list.vue')
    },
    {
        // 搜索列表
        path: '/search-list',
        name: 'searchList',
        component: () => import( /* webpackChunkName: "searchList" */ '../views/searchList/list.vue'),
        meta: {
            title: 'finds.searchList',
            head: 2,
            roles: ['VISITOR', '']
        }
    },
    {
        // 新闻路由
        path: '/news',
        name: 'newsList',
        component: () => import('../views/news/index.vue'),
        meta: {
            head: 2,
            title: 'News'
        }
    },
    {
        // 新闻详情
        path: '/news/:id',
        name: 'newsDetail',
        component: () => import('../views/news/detail.vue'),
        meta: {
            head: 2,
            title: 'News Detail'
        }
    },
    {
        // 意向订单
        path: '/potential-order',
        name: 'potentialOrder',
        component: () => import('../views/dash/potentialOrder.vue'),
        meta: {
            title: 'order.Potential Order Management',
            roles: ['VISITOR', 'ACTOR']
        }
    },
    {
        // 直播数据统计--暂时不用
        path: '/statistical',
        name: 'statistical',
        component: () => import('../views/statistical/statistical.vue'),
        meta: {
            head: 1
        }
    },
    {
        // 展商/客商数据报告
        path: '/report/:type(actorIndex|personReport)',
        name: 'report',
        component: () => import('../views/data/report.vue'),
        meta: {
            head: 1,
            title: 'hm.',
            whiteBackground: true,
            roles: {
                'actorIndex': ['ACTOR'],
                'personReport': ['VISITOR']
            }
        }
    },
    {
        // 更新日志
        path: '/versionLog',
        name: 'versionLog',
        component: () => import('../views/version/versionLog.vue'),
        meta: {
            title: 'version.versionLog',
            roles: ['VISITOR', 'ACTOR']
        }
    },
    {
        path: '*',
        name: 'noFind404',
        meta: {
            title: 'Page not found',
            head: 2
        },
        component: () => import( /* webpackChunkName: "404" */ '../views/404.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: config.route || '',
    scrollBehavior: () => ({
        y: 0
    }),
    routes
})

export default router
